import { createReducer } from "@reduxjs/toolkit";
import { loadingData, savingData, setEditPageTitle } from "./commonAction";

export interface Common {
  isSaving: boolean;
  isLoading: boolean;
  editPageTitle: string;
}
const initialState: Partial<Common> = {
  editPageTitle: "",
};

export const commonReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(savingData, (state, action) => {
      state = {
        ...state,
        isSaving: action.payload,
      };
      return state;
    })
    .addCase(loadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(setEditPageTitle, (state, action) => {
      state = {
        ...state,
        editPageTitle: action.payload,
      };
      return state;
    });
});
